export const widgetColorFields = ['widget_background_color', 'widget_text_color', 'widget_link_color']

export const popupColorFields = ['popup_overlay_color', 'popup_header_text_color', 'popup_body_text_color']

export const popupHeaderImageField = 'popup_header_image'
